<template>
  <div>
    <!--<v-btn> Generate Invoice</v-btn> -->
    <v-btn
      class="messagebtn accounts-generate-invoice-btn"
      v-if="countInvoice != 0"
      @click.stop="dialog = true"
      title="Generate Invoice"
      flat
      target="_blank"
      color="white darken-1"
    >
      Generate Invoice ({{ countInvoice }})
    </v-btn>
    <v-btn
      class="messagebtn accounts-generate-invoice-btn"
      @click.stop="dialog = true"
      title="Generate Invoice"
      flat
      target="_blank"
      :disabled="!assignmentIds.length"
      v-else
      prepend-icon
      color="white darken-1"
    >
      Generate Invoice
    </v-btn>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="36rem"
      content-class="invoice-type-dialog"
    >
      <v-form ref="form">
        <v-card class="invoice-type-card">
          <header class="oms-modal-header">
            <div class="oms-modal-header__brand">
              <div class="oms-modal-header__badge" aria-hidden="true">
                <v-icon>receipt</v-icon>
              </div>
              <div class="oms-modal-header__copy">
                <h2 class="oms-modal-header__title">Select Invoice Type</h2>
              </div>
            </div>
            <v-btn
              class="oms-modal-header__close"
              icon
              aria-label="Close select invoice type"
              title="Close"
              @click.prevent="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="loading"
          ></v-progress-linear>
          <div class="invoice-type-body">
            <v-radio-group
              v-model="selected"
              mandatory
              hide-details
              class="invoice-type-group"
            >
              <v-radio
                label="Single Invoice: Single Assignment Basis"
                value="INVOICE_PER_ASSIGNMENT"
                class="invoice-type-option"
              ></v-radio>
              <v-radio
                label="Single Invoice: Multiple Assignment details"
                value="SINGLE_INVOICE_FOR_ALL_ASSIGNMENTS"
                class="invoice-type-option"
                :disabled="assignmentIds.length == 1"
              ></v-radio>
              <p v-if="assignmentIds.length == 1" class="invoice-type-note">
                Select two or more assignments to combine them in one invoice.
              </p>
            </v-radio-group>
          </div>
          <div class="invoice-type-actions">
            <v-btn
              class="messagebtn accounts-generate-invoice-btn"
              title="Generate Invoice"
              flat
              target="_blank"
              :disabled="!selected.length"
              @click="fetchBank()"
              prepend-icon
              color="white darken-1"
            >
              <span>Generate Invoice</span>
            </v-btn>
          </div>
        </v-card>
        <InvoiceStartedDialog v-model="invoiceDialog" />
        <GenerateInvoiceDialog
          :open="bankDialog"
          v-model="bank"
          :banks="bankInfo"
          permission="generate-purchase-invoice"
          :loading="loading"
          @change="setCustomerValues"
          @cancel="closeBankInfo()"
          @confirm="generateMultipleInvoice()"
        />
      </v-form>
    </v-dialog>
    <v-snackbar
      :timeout="4000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
  </div>
</template>

<script>
import { StorageKeys } from "../../../constants/constants";
import { EventBus } from "../../../event-bus.js";
import GenerateInvoiceDialog from "@/components/Common/GenerateInvoiceDialog";
import InvoiceStartedDialog from "@/components/Common/InvoiceStartedDialog";
export default {
  components: { GenerateInvoiceDialog, InvoiceStartedDialog },
  data() {
    return {
      error: "",
      dialog: false,
      invoicingCity: "",
      invoicingCountry: "",
      bankInfo: [],
      bankName: [],
      bank: "",
      beneficiaryName: "",
      branchCode: "",
      ibanNo: "",
      swiftCode: "",
      accountNo: "",
      bankId: "",
      invoiceDialog: false,

      bankDialog: false,
      loading: false,

      selected: [],
      single: "",
    };
  },
  props: {
    assignmentIds: Array,
    countInvoice: Number,
    selectedCustomerForInvoice: Object,
  },
  methods: {
    close() {
      this.selected = [];
      this.loading = false;
      this.dialog = false;
    },

    setCustomerValues(val) {
      var data = this.bankInfo.filter((v) => {
        if (v.value === val) return v;
      });

      (this.beneficiaryName = data[0].beneficiaryName),
        (this.branchCode = data[0].branchCode),
        (this.accountNo = data[0].accountNo),
        (this.ibanNo = data[0].ibanNo),
        (this.bankId = data[0].bankId),
        (this.swiftCode = data[0].swiftCode);
      // this.beneficiaryName = data[0].beneficiaryName;
    },
    fetchBank() {
      this.bankDialog = true;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        invoicingCity: {
          code: this.selectedCustomerForInvoice.invoicingCity,
        },
        invoicingCountry: {
          code: this.selectedCustomerForInvoice.invoicingCountry,
        },
      };
      let { apiUrl } = this.constants;
      this.axios.post(`${apiUrl}/accounts/getBankDetails`, body, config).then(
        (response) => {
          const { data = null } = response.data;
          /* Replace, never append, so reopening the bank step does not list
             every bank again. */
          this.bankInfo = data.map((element) => ({
            text: element.bankName,
            value: element._id,
            beneficiaryName: element.beneficiaryName,
            branchCode: element.branchCode,
            accountNo: element.accountNo,
            ibanNo: element.ibanNo,
            bankId: element._id,
            swiftCode: element.swiftCode,
          }));
        },
        (error) => {
          this.error = "Something went wrong. Please try again later!";
          this.loading = false;
        }
      );
    },

    generateInvoice() {
      if (!this.selectedCustomerForInvoice["invoiceDay"]) {
        this.$emit("customerInvoiceFailed", {
          ...this.selectedCustomerForInvoice,
        });
        return false;
      }
      this.dialog = true;
    },
    chooseBank() {
      this.bankDialog = true;
    },
    closeBankInfo() {
      this.bankDialog = false;
      this.bankInfo = [];
      this.bank = "";
      (this.beneficiaryName = ""),
        (this.branchCode = ""),
        (this.accountNo = ""),
        (this.ibanNo = ""),
        (this.bankId = ""),
        (this.swiftCode = "");
    },
    generateMultipleInvoice() {
      if (!this.selected.length) {
        this.loading = false;
        this.error = "Please select invoicing type !";
        return;
      }
      if (!this.bank) {
        this.loading = false;
        this.error = "Please choose bank before generating the invoice";
        return;
      }
      this.loading = true;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let body = {
        assignmentIds: this.$props.assignmentIds,
        type: this.selected.toString(),
        bankId: this.bankId,
      };
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .post(
          `${this.constants.apiUrl}/dmsAdmin/generate-assignment-invoice`,
          body,
          config
        )
        .then(
          (response) => {
            const { status, data } = response.data;
            this.close();
            this.closeBankInfo();
            this.invoiceDialog = true;
            this.loading = false;
            localStorage.removeItem("customerFilter");
            this.$emit("reset-list");
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
            localStorage.removeItem("customerFilter");
          }
        );
    },
  },
};
</script>
<style lang="scss">
.typebox {
  display: block !important;
  .boxborder {
    align-items: center !important;
    border-bottom: 1px solid lightgray;
    display: flex !important;
    margin-right: 0;
    min-height: 3.125rem;
    padding: 0.625rem 0 !important;
    position: relative;
  }
  .boxborder .v-input__control,
  .boxborder .v-input__slot {
    width: 100%;
  }
  .boxborder .v-input__slot {
    align-items: center !important;
    display: flex !important;
  }
  .boxborder .v-label {
    flex: 1 1 auto;
    line-height: 1.35;
    min-width: 0;
    overflow-wrap: anywhere;
    padding-right: 1rem;
    text-align: left !important;
    white-space: normal;
    word-break: normal;
  }
  .boxborder .v-input--selection-controls__input {
    flex: 0 0 2rem;
    margin-left: auto;
    order: 2;
    position: static !important;
    right: auto !important;
  }
}
</style>

<style scoped>
.fonthead {
  font-size: 20px;
}
</style>
<style src="../../../styles/invoice-type-dialog.css"></style>
